import type { CalendarColor, Label, TemplateType } from "@/api";

/**
 * Google Calendar's event colour names by colorId. The API returns only ids
 * and hex values; these are the names Google shows in its own picker for
 * the eleven event colours (the newer 24-colour UI palette is not available
 * to events through the API).
 */
const googleColorNames: Record<string, string> = {
  "1": "Lavender",
  "2": "Sage",
  "3": "Grape",
  "4": "Flamingo",
  "5": "Banana",
  "6": "Tangerine",
  "7": "Peacock",
  "8": "Graphite",
  "9": "Blueberry",
  "10": "Basil",
  "11": "Tomato",
};

/** Human name for a Google event colour, falling back to its hex. */
export function colorName(color: CalendarColor): string {
  return googleColorNames[color.id] ?? color.hex;
}

/** Resolve a Label's Google colorId to hex via the palette from api.colors(). */
export function labelHex(
  colors: CalendarColor[],
  label: Label,
): string | undefined {
  return colors.find((c) => c.id === label.google_color_id)?.hex;
}

/** Display names from business-requirements.md § Type. Wire values differ. */
export const templateTypes: {
  value: TemplateType;
  label: string;
  hint: string;
}[] = [
  {
    value: "repeating",
    label: "Repeating",
    hint: "Recurring, tracked with a Streak",
  },
  { value: "project", label: "Project", hint: "Limited effort that depletes" },
  { value: "once_off", label: "OnceOff", hint: "Used once, then discarded" },
];

export function typeLabel(type: TemplateType): string {
  return templateTypes.find((t) => t.value === type)?.label ?? type;
}
